import PolicyDocumentPage from '../../components/policies/PolicyDocumentPage';

function PrivacyPolicyPage() {
  return (
    <PolicyDocumentPage
      type="privacy"
      title="Privacy Policy"
      eyebrow="Customer policy"
      emptyMessage="No Privacy Policy has been published yet."
    />
  );
}

export default PrivacyPolicyPage;
